import { makeVar, FieldPolicy } from '@apollo/client';
// Using autorun to mirror string values into reactive variables
// tslint:disable-next-line:forbid-import
import { autorun } from 'mobx';

export function createObservedTypePolicy<T>(getObserved: () => T): FieldPolicy {
    const reactiveVar = makeVar(getObserved());
    autorun(() => {
        const observedValue = getObserved();
        // Trigger to broadcast apollo state changes incoming from satchel changes
        reactiveVar(observedValue);
    });
    return {
        read() {
            return reactiveVar();
        },
    };
}
